import ConstructionIcon from "@mui/icons-material/Construction";
import { ProjectPaymentList } from "./ProjectPaymentList";
import { ProjectPaymentCreate } from "./ProjectPaymentCreate";
import { ProjectPaymentEdit } from "./ProjectPaymentEdit";

export default {
  list: ProjectPaymentList,
  create: ProjectPaymentCreate,
  edit: ProjectPaymentEdit,
  icon: ConstructionIcon,
  label: "Work payments",
  options: { label: "Work payments" },
  name: "projectPayments",
};
